module.exports = __webpack_public_path__ + "static/media/no-shop.8a1abb07.svg";